import { connect } from "react-redux";
import ViewPocs from "./viewPocs";
import { bindActionCreators } from "redux";
import {
  getPocListing,
  updatePocStatus,
} from "services/redux/sales/pocListing/action";

const mapStateToProps = (state) => ({
  pocList: state.pocListReducer.pocList,
  updateStatus: state.pocListReducer.updatePocStatus,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPocListing,
      updatePocStatus,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewPocs);
